// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"GenericPage_pageContainer__2isWo","controlTitle":"GenericPage_controlTitle__3v121","controlCloseText":"GenericPage_controlCloseText__2EFUQ"};